import {useMutation} from '@tanstack/react-query'
import {useSnackbar} from 'notistack'
import api, {SendFeedback} from 'src/services/api'
import handleErrorWithSnackbar from 'src/utilities/handleErrorWithSnackbar'

export default function usePostFeedback() {
  const {enqueueSnackbar} = useSnackbar()
  const mutation = useMutation({
    mutationFn: async ({eventId, body}: {eventId: number; body: SendFeedback}) => {
      return await api.events.postFeedback(eventId, body)
    },
    onSuccess: async () => {
      enqueueSnackbar('Feedback enviado com sucesso', {variant: 'success'})
    },
    onError: (error) => {
      handleErrorWithSnackbar(enqueueSnackbar, error, 'Erro ao enviar feedback do evento')
    },
  })
  return mutation
}
